import React from 'react';
import { DatoCmsContactInfoListItem, DatoCmsLink } from '../../../schema/datocms/blocks';
import { getTextAlignmentClass } from '../../../utilities';
import ContactLink from '../../contact-link/contact-link';
import HtmlStringComponent from '../../html-string/html-string-component';
import IconWithText from '../../icon/icon-with-text';
import Link from '../../link/link';
import { useThemeClassMap } from '../../theme/useThemeClassMap';

const ContactInfoListItemComponent = ({ theme, title, titleAlignment, hoursOfOperation, phoneNumber,
    emailAddress, descriptionHtml, links
}: DatoCmsContactInfoListItem): React.ReactElement => {
    const link: DatoCmsLink | undefined = links && links.length > 0 ? links[0] : undefined;
    const themeClass = useThemeClassMap(theme);

    let hoursContent: JSX.Element | undefined = undefined;
    if (hoursOfOperation && hoursOfOperation.length > 0) {
        hoursContent = <IconWithText iconName={hoursOfOperation[0].iconName} text={hoursOfOperation[0].displayText} className='text-theme-primary-text' />;
    }

    let phoneContent: JSX.Element | undefined = undefined;
    if (phoneNumber) {
        phoneContent = <ContactLink iconName='phone' {...phoneNumber} />;
    }

    let emailContent: JSX.Element | undefined = undefined;
    if (emailAddress) {
        emailContent = <ContactLink iconName='email' {...emailAddress} />;
    }

    let linkContent: JSX.Element | undefined = undefined;
    if (link) {
        linkContent =
            <Link internalPageReference={link.internalPageReference}
                internalPageSectionId={link.internalSectionComponentId}
                externalPageUrl={link.externalPageUrl}
                title={link.descriptiveTitle}>
                <IconWithText iconName='link' text={link.displayText || ''} />
            </Link>;
    }

    let contactSection: JSX.Element | undefined = undefined;
    if (phoneContent || emailContent || linkContent) {
        contactSection = <div className='flex space-x-4 justify-center lg:justify-start'>
            {phoneContent}
            {emailContent}
            {linkContent}
        </div>;
    }

    const titleContent = (title && <h3 className={`text-center md:${getTextAlignmentClass(titleAlignment)}`}>{title}</h3>);

    const listItem = (
        <div className={`${themeClass} bg-theme-primary p-4 flex flex-col items-center md:items-start`}>
            <div className="space-y-4">
                { titleContent }

                { hoursContent }

                { contactSection }

                { descriptionHtml && <HtmlStringComponent htmlString={descriptionHtml} />}
            </div>
        </div>
    );

    return listItem;
};

export default ContactInfoListItemComponent;
